import { Fragment, useEffect, useState, useRef } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import React from 'react';
import { getDate, getDateFormatData, getStatus } from '../../utils/Helper';
import { useNavigate } from 'react-router-dom';
import ToastDefault from '../FieldComponets/Toast';
import { DashboardRedirectionAction } from '../../Redux/Action/CommonAction';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { LinkButtons } from "../FieldComponets/LinkButtons";
import { BookingGetAction } from '../../Redux/Action/BokkingAction';


function BookingMangementList() {

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const bookinglist = useSelector((state: any) => state.BookingGetState);
  const DashboardRedirectionStatedata = useSelector((state: any) => state.DashboardRedirectionState)
  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [openSerach, setOpenSerach] = useState(false)
  const [sorting, setSorting] = useState<any>(['ASC']);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchOther, setSearchOther] = useState<any>('');
  const [searchValue, setSearchValue] = useState<any>('');

  const [rowCount, setRowCount] = useState(0);
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')


  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: 'S.NO',
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50,
    },
    {
      accessorKey: 'u_id',
      header: 'Booking ID',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
   
    {
      accessorKey: 'service_details.name',
      header: 'Service Name',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'user_details.name',
      header: 'Customer Name',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
        accessorKey: 'salon_details.salon_name',
        header: 'Salon Name',
        enableSorting: false,
        enableColumnOrdering: false,
        enableColumnDragging: false,
        enableColumnFilter: false
      },
      {
        accessorKey: 'status',
        header: 'Booking Status',
        accessorFn: (row: any) => {
          return   getStatus(row?.status)  
         },
        enableSorting: false,
        enableColumnOrdering: false,
        enableColumnDragging: false,
        enableColumnFilter: false
      },
      {
        accessorKey: 'booking_status',
        header: 'Booking Type',
        accessorFn: (row: any) => {
          return   row?.booking_status == "1" ? "Online":"Offline"
         },
        enableSorting: false,
        enableColumnOrdering: false,
        enableColumnDragging: false,
        enableColumnFilter: false
      },
      {
        accessorKey: 'amount',
        header: 'Booking Price',
        enableSorting: false,
        enableColumnOrdering: false,
        enableColumnDragging: false,
        enableColumnFilter: false
      },  
      // {
      //   accessorKey: 'email4',
      //   header: 'Booking Type',
      //   enableSorting: false,
      //   enableColumnOrdering: false,
      //   enableColumnDragging: false,
      //   enableColumnFilter: false
      // },
    {
      accessorKey: 'booking_date',
      header: 'Booking Date',
      accessorFn: (row: { booking_date: any; }) => getDate(row.booking_date),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },

    {
      accessorKey: 'created_at',
      header: 'Created At',
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },

    {
      header: 'Action',
      size: 30,
      accessorFn: (row: { id: any; }) => <>
        <div className="btn-group action-btn-table">
          <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
            <span>
              <LinkButtons
                pageLink={`booking-detail`}
                pageID={row?.id}
                showEdit={false}
                showView={true}
                showDelete={false}
              />
            </span>
          </ul>
        </div>
      </>,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        const userStatus = DashboardRedirectionStatedata?.data
        // console.log(userStatus)
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );

        query.columnFilters.push({ id: "salon_id", value: userStatus?.salon_id })
        query.columnFilters.push({ id: "user_id", value: userStatus?.user_id })
        query.columnFilters.push({ id: "status", value: userStatus?.status })

        dispatch(DashboardRedirectionAction('RESET'));
        await dispatch(BookingGetAction(query));

      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    // searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    openSerach
  ]);
  useEffect(() => {
    setData(bookinglist?.data?.data?.rows);
    setRowCount(bookinglist?.data?.data?.count);
  }, [bookinglist?.data]);
 
  const handeldate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setStartDate(formattedDate);
  }

  const handelEnddate = (e: any) => {
    const formattedDate = moment(e).format('YYYY-MM-DD');
    setEndDate(formattedDate)
  }
  const resetSearchfilter = () => {
    setLoading(true)
    setStartDate('')
    setEndDate('')
    setSearchValue('')
    setSearchOther('')
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "start_date", value: "" },
      { id: "end_date", value: "" },
      { id: "search", value: "" }

    ]
    setColumnFilters(columnFilters)
  }
  const handleserach = (e: any) => {
    e.preventDefault()
    setLoading(true)
    const columnFilters = [
      { id: "start_date", value: startDate.trim() },
      { id: "end_date", value: endDate.trim() },
      { id: "search", value: searchValue?.trim()},
      { id: "booking_status", value: searchOther?.booking_status?.trim()},
      { id: "booking_type", value: searchOther?.booking_type}
    ]
    setColumnFilters(columnFilters)
  }
  const handleSearchValues = (e: any) => {
    const { name, value } = e.target; 
    setSearchOther((searchOther:any)  => ({...searchOther, [name]: value}));
  }
  
  return (
    <Fragment>
      {(loading || bookinglist?.loading) ? <Spinner /> : ""}


      <PageLayout
        title="Booking Management"
        breadcrumbs={{
          secLast: { 'link': '/booking-list', 'name': 'Booking Management' },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >
        <form ref={formRef} onSubmit={handleserach}>
         
          <div className='row gy-3 mt-3 mb-4'>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label>Start date</label>
              <DatePicker className="form-control"  placeholderText='MM/DD/YYYY'  value={startDate ? getDateFormatData(startDate) : ''} onChange={(e) => handeldate(e)}  onKeyDown={(e) => e.preventDefault()}/>
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label>End date</label>
              <DatePicker className="form-control" placeholderText='MM/DD/YYYY' value={endDate ? getDateFormatData(endDate) : ''} onChange={(e) => handelEnddate(e)} minDate={new Date(startDate)} onKeyDown={(e) => e.preventDefault()} />
            </div>
           
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label>All Booking</label>
              <select className='form-select shadow-none' name="booking_status" id="bookings" onChange={handleSearchValues}>
                <option value="">All bookings</option>
                <option value="0">Upcoming bookings</option>
                <option value="1">Completed bookings</option>
                <option value="2">Canceled bookings</option>
                 <option value="0">Rescheduled bookings</option> 
                 <option value="3">No shown-up bookings</option>
                </select></div>   

        <div className="col-md-4 col-lg-4 col-xl-3">
              <label>Booking Type</label>
              <select className='form-select shadow-none' name="booking_type" id="booking" onChange={handleSearchValues}>
                <option value="">All booking</option>
                <option value="1">Online</option>
                <option value="2">Offline</option>
              </select>
            </div> 

            <div className="row gy-3">
            <div className='col-md-6 col-lg-4 col-xl-3'>
              <div className="input-group w-100">
                <div className="input-group">
                  <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                  <input type='text' id="saerchId" name='search' className="form-control m-0" placeholder='Search by booking id' onChange={(e)=>setSearchValue(e.target.value)}  />
                </div>
              </div>
            </div>
            <div className="col-6">
              <button className='btn theme-bg text-white me-2'>Filter</button>
              <button className='btn btn-success' onClick={() => resetSearchfilter()} >Reset</button>
            </div>
          </div>
          </div>
        </form>
        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={true}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data', } : undefined}
            muiSearchTextFieldProps={{
              placeholder: 'Search from name',
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }
        <ToastDefault />
      </PageLayout>
    </Fragment>
  )
}


export default BookingMangementList